import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import { useAuth } from './lib/auth';
import { configMissing } from './lib/supabase';
import Account from './pages/Account';
import Catalog from './pages/Catalog';
import Customers from './pages/Customers';
import Jobs from './pages/Jobs';
import Login from './pages/Login';
import PublicQuote from './pages/PublicQuote';
import QuoteEditor from './pages/QuoteEditor';
import Quotes from './pages/Quotes';

export default function App() {
  const { loading, session, profile, signOut } = useAuth();
  const location = useLocation();

  if (configMissing) {
    return (
      <div className="login">
        <div className="card">
          <h1>Almost there</h1>
          <p className="muted">
            The app is missing its Supabase settings. Add <code>VITE_SUPABASE_URL</code> and{' '}
            <code>VITE_SUPABASE_ANON_KEY</code> to the Cloudflare Pages environment variables, then redeploy.
          </p>
        </div>
      </div>
    );
  }

  // Customer quote links work without signing in
  if (location.pathname.startsWith('/q/')) {
    return <Routes><Route path="/q/:token" element={<PublicQuote />} /></Routes>;
  }

  if (loading) return <div className="empty">Loading…</div>;
  if (!session) return <Login />;
  if (!profile) {
    return (
      <div className="login">
        <div className="card stack">
          <h1>No staff access</h1>
          <p className="muted">
            You're signed in as <b>{session.user.email}</b>, but that email isn't set up as Simply Totes staff. Ask an
            admin to add you.
          </p>
          <button onClick={signOut}>Sign out</button>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/quotes" replace />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/quotes/new" element={<QuoteEditor />} />
        <Route path="/quotes/:id" element={<QuoteEditor />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:id" element={<Jobs />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<Customers />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/account" element={<Account />} />
        <Route path="*" element={<Navigate to="/quotes" replace />} />
      </Route>
    </Routes>
  );
}
